'use client';

import dynamic from 'next/dynamic';
import type { LocalitySectionProps } from './LocalitySectionInner';

/**
 * Frontiere de chargement paresseux du sous-arbre /localites.
 *
 * RenderPage est un Server Component : le `dynamic()` qui y etait ne sortait pas
 * ces modules du groupe de chunks initial de la page, ils etaient donc
 * telecharges sur toutes les pages du site. L'`import()` doit partir d'un module
 * client, d'ou ce fichier.
 */
const LocalitySectionInner = dynamic(() => import('./LocalitySectionInner'));

export default function LocalitySection(props: LocalitySectionProps) {
  return <LocalitySectionInner {...props} />;
}
